import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.matches.shortlisted;

const getShortlisted = createSelector(getData, shortlisted => shortlisted);

export default getShortlisted;



// WEBPACK FOOTER //
// ./src/_selectors/matchesSelectors/getShortlisted.js